import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext } from "react";

function DummyCard() {
    const { isMobile } = useContext(BrowserDetectContext);
    return (
        <div
            style={{
                display: "flex",
                flex: isMobile ? "1 1 45%" : "1 1 23%",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white",
                padding: "20px 0",
            }}
        >
            <div
                style={{
                    borderRadius: "10px",
                    width: "93%",
                    padding: "10px",
                    boxShadow: "3px 2px 14.100000381469727px 0 rgba(254, 83, 31, 0.5)",
                }}
            >
                <VerticalFlex gap={10}>
                    <FlexChild>
                        <div
                            style={{
                                padding: "10px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}

                        >
                            <img width={"85%"} />
                        </div>
                    </FlexChild>
                    <FlexChild>
                        <Center>
                            <P size={15}>

                            </P>
                            <P size={20}>

                            </P>
                        </Center>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={20}>
                            <FlexChild justifyContent={"flex-end"}>
                                <P
                                    size={10}
                                    borderRadius={"30px"}
                                    color={"white"}
                                    backgroundColor={"#EC4715"}
                                    padding={"5px 15px"}
                                    cursor={"pointer"}

                                >
                                    구매하기
                                </P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-start"}>
                                <P
                                    size={10}
                                    borderRadius={"30px"}
                                    border={"1px solid #EC4715"}
                                    color={"#EC4715"}
                                    padding={"5px 15px"}

                                    cursor={"pointer"}
                                >
                                    장바구니
                                </P>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                </VerticalFlex>
            </div>
        </div>
    );
}

export default DummyCard;